/**
 * Translation keys for Content Metadata entity forms (tags and entries).
 * Reuses: ID_LABEL, TYPE_LABEL, TITLE_LABEL (common-entity-strings);
 * CODE_LABEL, DEFINITION_LABEL, DESCRIPTION_LABEL (lpf-strings).
 */
export const EN_CONTENT_METADATA_STRINGS = {
  CONTENT_METADATA: 'Content Metadata',
  CONTENT_METADATA_ENTRY: 'Content Metadata Entry',
  TAGS: '{count, plural, one {Tag} other {Tags}}',
  CONTENT_METADATA_SOURCE_ID_LABEL: 'Source ID',
  CONTENT_METADATA_SOURCE_SYSTEM_LABEL: 'Source System',
  CONTENT_METADATA_TAG_ATTRIBUTES_LABEL: 'Tag',
  CONTENT_METADATA_TAG_ACTIVE_LABEL: 'Active',
  CONTENT_METADATA_TAG_READ_ONLY_LABEL: 'Read Only',
  CONTENT_METADATA_TAG_CODE_SYSTEM_LABEL: 'Coding System',
  CONTENT_METADATA_TAG_CODE_LABEL: 'Code',
  CONTENT_METADATA_TAG_CODE_SYSTEM_HEALTH_CONTENT: 'Topic Page',
  CONTENT_METADATA_TAG_CODE_SYSTEM_CUSTOM_TAGS: 'League Platform Tag',
  CONTENT_METADATA_TAG_CODE_SYSTEM_HEALTH_SUBJECT: 'Health Subject',
  CONTENT_METADATA_TAG_CODE_SYSTEM_HEALTH_TOPICS: 'Health Topics',
  CONTENT_METADATA_TAG_NAME_LABEL: 'Name',
  CONTENT_METADATA_TAG_NAME_HINT:
    'Important: Follow the naming convention "[category selected] - [name]". For example, if you choose category "B0:IN0 / Benefits - Insurance" then the name should be "Benefits - Insurance - [name]"',
  CONTENT_METADATA_TAG_CATEGORY_LABEL: 'Category',
  CONTENT_METADATA_TAG_CATEGORY_HINT: 'The Health Topic category for this tag.',
  CONTENT_METADATA_TAG_CATEGORY_B0_LABEL: 'B0 / Benefits',
  CONTENT_METADATA_TAG_CATEGORY_B0_FS0_LABEL:
    'B0:FS0 / Benefits - Financial Accounts',
  CONTENT_METADATA_TAG_CATEGORY_B0_IN0_LABEL: 'B0:IN0 / Benefits - Insurance',
  CONTENT_METADATA_TAG_CATEGORY_B0_LD0_LABEL:
    'B0:LD0 / Benefits - Leave & Disability',
  CONTENT_METADATA_TAG_CATEGORY_C0_LABEL: 'C0 / Clinical Services',
  CONTENT_METADATA_TAG_CATEGORY_C0_DC0_LABEL:
    'C0:DC0 / Clinical Services - Dental Care',
  CONTENT_METADATA_TAG_CATEGORY_C0_DI0_LABEL:
    'C0:DI0 / Clinical Services - Diagnostics & Imaging',
  CONTENT_METADATA_TAG_CATEGORY_C0_OC0_LABEL:
    'C0:OC0 / Clinical Services - Optometric Care',
  CONTENT_METADATA_TAG_CATEGORY_C0_PC0_LABEL:
    'C0:PC0 / Clinical Services - Primary Care',
  CONTENT_METADATA_TAG_CATEGORY_C0_PS0_LABEL:
    'C0:PS0 / Clinical Services - Pharmacy Services',
  CONTENT_METADATA_TAG_CATEGORY_C0_SC0_LABEL:
    'C0:SC0 / Clinical Services - Specialty Care',
  CONTENT_METADATA_TAG_CATEGORY_C0_SS0_LABEL:
    'C0:SS0 / Clinical Services - Surgical Services',
  CONTENT_METADATA_TAG_CATEGORY_F0_LABEL: 'F0 / Family & Reproductive Health',
  CONTENT_METADATA_TAG_CATEGORY_F0_CO0_LABEL:
    'F0:CO0 / Family & Reproductive Health - Contraception',
  CONTENT_METADATA_TAG_CATEGORY_F0_FE0_LABEL:
    'F0:FE0 / Family & Reproductive Health - Fertility & Family Building',
  CONTENT_METADATA_TAG_CATEGORY_F0_PP0_LABEL:
    'F0:PP0 / Family & Reproductive Health - Postpartum',
  CONTENT_METADATA_TAG_CATEGORY_F0_PR0_LABEL:
    'F0:PR0 / Family & Reproductive Health - Pregnancy & Birth',
  CONTENT_METADATA_TAG_CATEGORY_H0_LABEL: 'H0 / Health Problem',
  CONTENT_METADATA_TAG_CATEGORY_H0_CA0_LABEL:
    'H0:CA0 / Health Problem - Cancer',
  CONTENT_METADATA_TAG_CATEGORY_H0_CV0_LABEL:
    'H0:CV0 / Health Problem - Cardiovascular',
  CONTENT_METADATA_TAG_CATEGORY_H0_DE0_LABEL:
    'H0:DE0 / Health Problem - Dermatology',
  CONTENT_METADATA_TAG_CATEGORY_H0_DG0_LABEL:
    'H0:DG0 / Health Problem - Digestive & Gut',
  CONTENT_METADATA_TAG_CATEGORY_H0_IC0_LABEL:
    'H0:IC0 / Health Problem - Infectious & Communicable Diseases',
  CONTENT_METADATA_TAG_CATEGORY_H0_IM0_LABEL:
    'H0:IM0 / Health Problem - Immunological',
  CONTENT_METADATA_TAG_CATEGORY_H0_ME0_LABEL:
    'H0:ME0 / Health Problem - Metabolic',
  CONTENT_METADATA_TAG_CATEGORY_H0_MU0_LABEL:
    'H0:MU0 / Health Problem - Musculoskeletal',
  CONTENT_METADATA_TAG_CATEGORY_H0_NE0_LABEL:
    'H0:NE0 / Health Problem - Neurological',
  CONTENT_METADATA_TAG_CATEGORY_H0_PA0_LABEL: 'H0:PA0 / Health Problem - Pain',
  CONTENT_METADATA_TAG_CATEGORY_H0_PI0_LABEL:
    'H0:PI0 / Health Problem - Physical Injuries',
  CONTENT_METADATA_TAG_CATEGORY_H0_PY0_LABEL:
    'H0:PY0 / Health Problem - Psychiatric',
  CONTENT_METADATA_TAG_CATEGORY_H0_RE0_LABEL:
    'H0:RE0 / Health Problem - Respiratory',
  CONTENT_METADATA_TAG_CATEGORY_P0_LABEL: 'P0 / Population Health',
  CONTENT_METADATA_TAG_CATEGORY_P0_CH0_LABEL:
    'P0:CH0 / Population Health - Pediatrics & Adolescent Health',
  CONTENT_METADATA_TAG_CATEGORY_P0_GE0_LABEL:
    'P0:GE0 / Population Health - Geriatric & Senior Health',
  CONTENT_METADATA_TAG_CATEGORY_P0_MH0_LABEL:
    "P0:MH0 / Population Health - Men's Health",
  CONTENT_METADATA_TAG_CATEGORY_P0_WH0_LABEL:
    "P0:WH0 / Population Health - Women's Health",
  CONTENT_METADATA_TAG_CATEGORY_S0_LABEL:
    'S0 / Proactive Care & Behavioural Management',
  CONTENT_METADATA_TAG_CATEGORY_S0_LM0_LABEL:
    'S0:LM0 / Proactive Care & Behavioural Management - Lifestyle Management',
  CONTENT_METADATA_TAG_CATEGORY_S0_PC0_LABEL:
    'S0:PC0 / Proactive Care & Behavioural Management - Preventative Care Guidelines',
  CONTENT_METADATA_TAG_CATEGORY_S0_SU0_LABEL:
    'S0:SU0 / Proactive Care & Behavioural Management - Substance Use',
  CONTENT_METADATA_TAG_CATEGORY_W0_LABEL: 'W0 / Wellness',
  CONTENT_METADATA_TAG_CATEGORY_W0_DN0_LABEL:
    'W0:DN0 / Wellness - Diet & Nutrition',
  CONTENT_METADATA_TAG_CATEGORY_W0_MW0_LABEL:
    'W0:MW0 / Wellness - Mental Wellness',
  CONTENT_METADATA_TAG_CATEGORY_W0_PW0_LABEL:
    'W0:PW0 / Wellness - Physical Wellness',
  CONTENT_METADATA_ENTRY_ATTRIBUTES_LABEL: 'Attributes',
  CONTENT_METADATA_ENTRY_CONTENT_METADATA_CONFIG_PROPERTIES_LABEL:
    'Content Metadata',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_LABEL: 'Referenced Content',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_SYSTEM_LABEL: 'Content ID System',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_TYPE_LABEL: 'Content Type',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_ID_LABEL:
    'Referenced Content Entity',
  CONTENT_METADATA_ENTRY_EFFECTIVE_PERIOD_LABEL: 'Effective Period',
  CONTENT_METADATA_ENTRY_EFFECTIVE_PERIOD_START_LABEL: 'Start Date',
  CONTENT_METADATA_ENTRY_EFFECTIVE_PERIOD_END_LABEL: 'End Date',
  CONTENT_METADATA_ENTRY_CONTENT_SUMMARY_LABEL: 'Content Summary',
  TARGET_USER_LABEL: 'Target User',
  TARGET_USER_GROUP_ENTRY_LABEL: 'Target User Group',
  TARGET_USER_GROUP_NAME_LABEL: 'Group Name',
  TARGET_USER_COHORT_ITEM_LABEL: 'Target Cohort',
  ADD_COHORT_BUTTON_LABEL: 'Add Cohort',
  COHORT_LABEL: 'Cohort',
  TARGET_USER_INCLUSION_CRITERIA_LABEL: 'Inclusion Criteria',
  TARGET_USER_EXCLUSION_CRITERIA_LABEL: 'Exclusion Criteria',
  TARGET_USER_CRITERION_LABEL: 'Criterion',
  ADD_INCLUSION_CRITERION_BUTTON_LABEL: 'Add Inclusion Criterion',
  ADD_EXCLUSION_CRITERION_BUTTON_LABEL: 'Add Exclusion Criterion',
  TARGET_USER_CRITERIA_ACID_REFLUX: 'Acid Reflux',
  TARGET_USER_CRITERIA_ALLERGIES: 'Allergies',
  TARGET_USER_CRITERIA_ANXIETY: 'Anxiety',
  TARGET_USER_CRITERIA_ASTHMA: 'Asthma',
  TARGET_USER_CRITERIA_BURNOUT: 'Burnout',
  TARGET_USER_CRITERIA_BURNOUT_V2: 'Burnout (v2)',
  TARGET_USER_CRITERIA_BURNOUT_FROM_WORK: 'Burnout from Work',
  TARGET_USER_CRITERIA_CHRONIC_PAIN: 'Chronic Pain',
  TARGET_USER_CRITERIA_COPD: 'COPD',
  TARGET_USER_CRITERIA_CORONARY_ARTERY_DISEASE: 'Coronary Artery Disease',
  TARGET_USER_CRITERIA_CURRENT_SMOKER: 'Current Smoker',
  TARGET_USER_CRITERIA_CURRENT_TOBACCO_USAGE: 'Current Tobacco Usage',
  TARGET_USER_CRITERIA_DENTAL_CARE: 'Dental Care',
  TARGET_USER_CRITERIA_DEPRESSION: 'Depression',
  TARGET_USER_CRITERIA_DIABETES: 'Diabetes',
  TARGET_USER_CRITERIA_DIGESTIVE_DISORDERS: 'Digestive Disorders',
  TARGET_USER_CRITERIA_EMPLOYMENT_STRESS: 'Employment Stress',
  TARGET_USER_CRITERIA_FEMALE: 'Female',
  TARGET_USER_CRITERIA_FINANCIAL_STRESS: 'Financial Stress',
  TARGET_USER_CRITERIA_FORMER_TOBACCO_USAGE: 'Former Tobacco Usage',
  TARGET_USER_CRITERIA_DIABETES_GESTATIONAL: 'Gestational Diabetes',
  TARGET_USER_CRITERIA_HAS_OBSTETRICIAN: 'Has Obstetrician',
  TARGET_USER_CRITERIA_HEADACHES: 'Headaches',
  TARGET_USER_CRITERIA_HEART_DISEASE: 'Heart Disease',
  TARGET_USER_CRITERIA_HEART_FAILURE: 'Heart Failure',
  TARGET_USER_CRITERIA_HIGH_BMI: 'High BMI',
  TARGET_USER_CRITERIA_HIGH_CHOLESTEROL: 'High Cholesterol',
  TARGET_USER_CRITERIA_HIGH_HEALTH_BEHAVIOR_RISK: 'High Health Behavior Risk',
  TARGET_USER_CRITERIA_HIGH_K10_DISTRESS: 'High K10 Distress',
  TARGET_USER_CRITERIA_HIGH_RISK_ALCOHOL_USE: 'High Risk Alcohol Use',
  TARGET_USER_CRITERIA_HIGH_STRESS: 'High Stress',
  TARGET_USER_CRITERIA_HX_GESTATIONAL_DIABETES:
    'History of Gestational Diabetes',
  TARGET_USER_CRITERIA_HX_POSTPARTUM_DEPRESSION:
    'History of Postpartum Depression',
  TARGET_USER_CRITERIA_HX_PRE_ECLAMPSIA: 'History of Pre-eclampsia',
  TARGET_USER_CRITERIA_HX_PREGNANCY_RELATED_BACK_PAIN:
    'History of Pregnancy-Related Back Pain',
  TARGET_USER_CRITERIA_HYPERTENSION: 'Hypertension',
  TARGET_USER_CRITERIA_K10_ANXIETY: 'K10 Anxiety',
  TARGET_USER_CRITERIA_K10_DEPRESSION: 'K10 Depression',
  TARGET_USER_CRITERIA_LESS_HEALTHY_DIET: 'Less Healthy Diet',
  TARGET_USER_CRITERIA_LOW_ACTIVITY_LEVEL: 'Low Activity Level',
  TARGET_USER_CRITERIA_LOW_BMI: 'Low BMI',
  TARGET_USER_CRITERIA_MALE: 'Male',
  TARGET_USER_CRITERIA_MENOPAUSE: 'Menopause',
  TARGET_USER_CRITERIA_MENTAL_HEALTH: 'Mental Health',
  TARGET_USER_CRITERIA_MIGRAINES: 'Migraines',
  TARGET_USER_CRITERIA_MODERATE_DIET_RISK: 'Moderate Diet Risk',
  TARGET_USER_CRITERIA_MODERATE_HEALTH_BEHAVIOR_RISK:
    'Moderate Health Behavior Risk',
  TARGET_USER_CRITERIA_MODERATE_K10_DISTRESS: 'Moderate K10 Distress',
  TARGET_USER_CRITERIA_MODERATE_RISK_ALCOHOL_USE: 'Moderate Risk Alcohol Use',
  TARGET_USER_CRITERIA_NOT_ACTIVE: 'Not Active',
  TARGET_USER_CRITERIA_OBESE: 'Obese',
  TARGET_USER_CRITERIA_OVERWEIGHT: 'Overweight',
  TARGET_USER_CRITERIA_PERCEIVED_ALCOHOL_USE: 'Perceived Alcohol Use',
  TARGET_USER_CRITERIA_PERIMENOPAUSE: 'Perimenopause',
  TARGET_USER_CRITERIA_PHYS_DISABILITY: 'Physical Disability',
  TARGET_USER_CRITERIA_POOR_FRUIT_INTAKE: 'Poor Fruit Intake',
  TARGET_USER_CRITERIA_POOR_HEALTH_PERCEPTION: 'Poor Health Perception',
  TARGET_USER_CRITERIA_POOR_MENTAL_HEALTH_PERCEPTION:
    'Poor Mental Health Perception',
  TARGET_USER_CRITERIA_POOR_SLEEP: 'Poor Sleep',
  TARGET_USER_CRITERIA_POOR_VEGETABLE_INTAKE: 'Poor Vegetable Intake',
  TARGET_USER_CRITERIA_POSITIVE_AUDIT_C_SCREEN: 'Positive AUDIT-C Screen',
  TARGET_USER_CRITERIA_POSITIVE_GAD_2_SCREEN: 'Positive GAD-2 Screen',
  TARGET_USER_CRITERIA_POSITIVE_GAD_7_SCREEN: 'Positive GAD-7 Screen',
  TARGET_USER_CRITERIA_POSITIVE_HEALTHY_HEART_SCREEN:
    'Positive Healthy Heart Screen',
  TARGET_USER_CRITERIA_POSITIVE_PHQ_2_SCREEN: 'Positive PHQ-2 Screen',
  TARGET_USER_CRITERIA_POSITIVE_PREDIABETES_SCREEN:
    'Positive Prediabetes Screen',
  TARGET_USER_CRITERIA_PREDIABETES: 'Prediabetes',
  TARGET_USER_CRITERIA_PREGNANT: 'Pregnant',
  TARGET_USER_CRITERIA_PRIMARY_CARE: 'Primary Care',
  TARGET_USER_CRITERIA_RISK_FACTORS_FOR_CANCER: 'Risk Factors for Cancer',
  TARGET_USER_CRITERIA_RISK_FACTORS_FOR_MENTAL_HEALTH:
    'Risk Factors for Mental Health',
  TARGET_USER_CRITERIA_SDOH: 'SDOH',
  TARGET_USER_CRITERIA_SDOH_V2: 'SDOH v2',
  TARGET_USER_CRITERIA_SKIN_CONDITION: 'Skin Condition',
  TARGET_USER_CRITERIA_SOCIAL_ISOLATION: 'Social Isolation',
  TARGET_USER_CRITERIA_SOMEWHAT_ACTIVE: 'Somewhat Active',
  TARGET_USER_CRITERIA_TRYING_TO_CONCEIVE: 'Trying to Conceive',
  TARGET_USER_CRITERIA_DIABETES_TYPE_1: 'Type 1 Diabetes',
  TARGET_USER_CRITERIA_DIABETES_TYPE_2: 'Type 2 Diabetes',
  TARGET_USER_CRITERIA_VERY_HIGH_K10_DISTRESS: 'Very High K10 Distress',
  TARGET_USER_CRITERIA_WORKLOAD_STRESS: 'Workload Stress',
  CONTENT_METADATA_ENTRY_TAGS_LABEL: 'Tags',
  CONTENT_METADATA_ENTRY_TAG_ENTRY_LABEL: 'Tag',
  CONTENT_METADATA_ENTRY_TAG_ENTRY_TAG_LABEL: 'Tag',
  CONTENT_METADATA_ENTRY_TAGS_STATUS_LABEL: 'Tag Status',
  CONTENT_METADATA_ENTRY_TAGS_STATUS_SUGGESTED: 'Suggested',
  CONTENT_METADATA_ENTRY_TAGS_STATUS_ACCEPTED: 'Accepted',
  CONTENT_METADATA_ENTRY_TAGS_STATUS_REJECTED: 'Rejected',

  TITLE_HINT: 'Display title for this item.',
  DESCRIPTION_HINT: 'Short description or explanation.',
  CODE_HINT: 'Code used to identify the tag uniquely.',
  DEFINITION_HINT: 'What does this tag describe? Minimum 20 characters.',
  CONTENT_METADATA_TAG_CODE_SYSTEM_HINT:
    'Note: If you need a new category, please contact your implementation team. These categories have a direct impact on app functionality.',
  CONTENT_METADATA_TAG_ACTIVE_HINT:
    'Turn this off to tell the tagging pipeline to remove this tag from content. It will no longer be assigned to content.',
  CONTENT_METADATA_TAG_READ_ONLY_HINT: 'Whether the tag is read-only.',
  CONTENT_METADATA_ENTRY_ATTRIBUTES_HINT: 'Entry attribute values.',
  CONTENT_METADATA_ENTRY_CONTENT_METADATA_CONFIG_PROPERTIES_HINT:
    'This entity contains the metadata associated with a specific piece of content.',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_HINT:
    'The content (campaign, activity, questionnaire, etc.) this entry refers to.',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_TYPE_HINT:
    'Select the type of the referenced content.',
  CONTENT_METADATA_ENTRY_REFERENCED_CONTENT_ID_HINT:
    'Choose the specific content item to associate with this metadata.',
  CONTENT_METADATA_ENTRY_EFFECTIVE_PERIOD_HINT:
    'When this metadata entry is in effect.',
  CONTENT_METADATA_ENTRY_CONTENT_SUMMARY_HINT:
    'Summary (title, description, source) for the referenced content.',
  CONTENT_METADATA_SOURCE_ID_HINT:
    'Identifier of the source (e.g. user or system that created or owns this).',
  CONTENT_METADATA_SOURCE_SYSTEM_HINT:
    'Code system or namespace for the source identifier.',
  TARGET_USER_HINT:
    'Audience or user targeting for this content. Applies if the user fits into one or more of the categories below.',
  COHORT_HINT: 'Select a cohort for audience targeting.',
  TARGET_USER_GROUP_NAME_HINT:
    'A descriptive name to identify this target user group.',
  TARGET_USER_INCLUSION_CRITERIA_HINT:
    'Criteria for users who are included (e.g. eligible to see this). User must meet ALL criteria listed below.',
  TARGET_USER_EXCLUSION_CRITERIA_HINT:
    'Criteria for users who are excluded (e.g. not eligible). User must not meet ANY of the criteria listed below.',
  CONTENT_METADATA_ENTRY_TAGS_HINT:
    'Tags applied to this content metadata entry. Note: removing a tag is not permanent — the tagging pipeline may re-suggest it on the next run. To keep a tag off the entry, set its status to "Rejected" instead.',
  CONTENT_METADATA_ENTRY_TAGS_STATUS_HINT:
    "Indicates whether the tag is suggested, accepted, or rejected. By default, tags are 'suggested' and may or may not be removed by the tagging pipeline. 'Accepted' means that the tagging pipeline will not remove this tag. 'Rejected' means that this tag will be ignored by recommendation systems.",
  CONTENT_METADATA_ENTRY_TAG_ENTRY_TAG_HINT:
    'Select the tag to assign to the referenced content.',
  CONTENT_METADATA_ENTRY_REFERENCED_CAMPAIGN_LABEL: 'Campaign',
  CONTENT_METADATA_ENTRY_REFERENCED_ACTIVITY_LABEL: 'Activity',
  CONTENT_METADATA_ENTRY_REFERENCED_QUESTIONNAIRE_LABEL: 'Questionnaire',
  CONTENT_METADATA_ENTRY_REFERENCED_HEALTH_CONTENT_LABEL: 'Health Content',
};
